import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import { emptyArray } from 'src/utils/helpers';

interface ISkeletonBlockProps {
  refund?: boolean;
}

const SkeletonsBlock: FC<ISkeletonBlockProps> = ({ refund }: ISkeletonBlockProps): JSX.Element => {
  return (
    <div className="d-flex flex-column gap-10">
      <Skeleton width={150} height={21.59} className="mb-2" />

      <div className="d-flex flex-column gap-10">
        <Skeleton width={200} height={21.59} />
        {refund ? null : <Skeleton width={360} height={46} style={{ borderRadius: 12 }} />}
      </div>

      <div className="d-flex flex-column gap-10">
        <Skeleton width={450} height={143} style={{ borderRadius: 10 }} />
        <Skeleton width={30} height={16.8} />
      </div>
    </div>
  );
};

const OrderSystemNotificationSkeletons: FC = (): JSX.Element => {
  return (
    <div className="order-system-notification pr-4">
      {emptyArray(1).map((item, index) => (
        <SkeletonsBlock key={'skeleton-' + String(index)} />
      ))}
      <SkeletonsBlock refund />
    </div>
  );
};

export default OrderSystemNotificationSkeletons;
